/**
 *    Copyright 2018 the original author or authors
 * 
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 * 
 *        http://www.apache.org/licenses/LICENSE-2.0
 * 
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */

import {TiffImage} from './tiff-image';
import {OpenLayerToolType} from '../utils';
import { LatLng } from './lat-lang';
import { EventEmitter } from '@angular/core';


export class OlOptions{
    tiffImage : TiffImage;
    drawEmmiter : EventEmitter<any>;
    deleteEmmiter: EventEmitter<any>;
    drawType ?: OpenLayerToolType;
    tooltype ?: string;
    points ?: Array<LatLng>;
    color ?: string; 
}